<template>
  <div class="clinic-selector">
    <v-select :id="id" class="wabident-selector" :options="clinics" :value="value" @input="onInput"
      :reduce="x => x.value" :placeholder="placeholder"></v-select>
    <label :for="id" class="wabident-info">{{ label }}</label>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      required: true,
    },
    value: {
      required: true,
    },
    label: {
      default: 'Clínica'
    },
    placeholder: {
      default: 'Elige Clínica',
    },
  },
  computed: {
    clinics() {
      if (!this.clinic) {
        return [];
      }

      let ret = [];
      for (const clinic_id in this.clinic.clinic_names) {
        ret.push({
          label: this.clinic.clinic_names[clinic_id],
          value: Number(clinic_id),
        });
      }
      return ret;
    },
    ...mapGetters(['clinic'])
  },
  methods: {
    onInput(v) {
      this.$emit('input', v);
    },
  }
}
</script>
